export default {"src":"/_next/static/media/DataAxle.5969596e.svg","height":36,"width":46};